import React from 'react';
import { Typography as AntdTypo } from 'antd';

export interface TypographyProps {
  styleid: number;
  children: any;
  style?: React.CSSProperties;
}

// Typhography component. Returns styled text based on the styles in the summerwood styleguide, Typography section
// https://www.figma.com/file/kXv9hZaV9dourRVMBRFHHF/Summerwood_Styleguide?node-id=0%3A1

const Typography: React.FunctionComponent<TypographyProps> = ({
  children,
  styleid,
  style,
}) => {
  const styles = [
    <AntdTypo.Text //0
      style={{
        fontFamily: 'Gibson Semibold',
        fontSize: '40px',
        lineHeight: '40px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //1
      style={{
        fontFamily: 'Gibson Book',
        fontSize: '26px',
        lineHeight: '26px',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //2
      style={{
        fontFamily: 'Gibson Semibold',
        fontSize: '22px',
        lineHeight: '22px',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //3
      style={{
        fontFamily: 'Gibson Medium',
        fontSize: '22px',
        letterSpacing: '0.04em',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //4
      style={{
        fontFamily: 'Gibson Book',
        fontSize: '16px',
        letterSpacing: '0.04em',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //5
      style={{
        fontFamily: 'Gibson Semibold',
        fontSize: '16px',
        letterSpacing: '0.04em',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //6
      style={{
        fontFamily: 'Gibson Book',
        fontSize: '14px',
        letterSpacing: '0.02em',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //7
      style={{
        fontFamily: 'Gibson Book Italic',
        fontStyle: 'italic',
        fontSize: '14px',
        letterSpacing: '0.02em',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //8
      style={{
        fontFamily: 'Gibson Medium',
        fontSize: '14px',
        letterSpacing: '0.02em',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //9
      style={{
        fontFamily: 'Gibson Book',
        fontSize: '12px',
        letterSpacing: '0.02rem',
        lineHeight: '15px',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //10
      style={{
        fontFamily: 'Gibson Medium',
        fontSize: '12px',
        letterSpacing: '0.02em',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //11
      style={{
        fontFamily: 'Gibson Semibold',
        fontSize: '18px',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
    <AntdTypo.Text //12
      style={{
        fontFamily: 'Gibson Semibold',
        fontSize: '23px',
        lineHeight: '23px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: Theme['@black'],
        ...style,
      }}
    >
      {children}
    </AntdTypo.Text>,
  ];

  return styles[styleid];
};

export default Typography;
